import React from 'react';
import PropTypes from 'prop-types';
import {NavLink} from 'react-router-dom';
import classnames from 'classnames';
import markNotAllFilled from 'common/assets/markNotAllFilled.svg';
import markAllFilled from 'common/assets/markAllFilled.svg';
import styles from './styles.module.scss';

const FancyLink = React.forwardRef((
  {navigate, children, href, ...props},
  ref
) => {
  return (
    <button ref={ref} {...props} onClick={navigate}>
      {children}
    </button>
  );
});

const StepNumber = ({
                      status,
                      path,
                      hoverTopic,
                      topic,
                      stepIcon,
                      disabled
                    }) => {
  const getIconProps = () => {
    switch (status) {
      case 2:
        return {src: markAllFilled, alt: 'markAllFilled'};
      case 1:
        return {src: markNotAllFilled, alt: 'markNotAllFilled'};
      default:
        return null;
    }
  };

  return (
    <div
      className={styles.stepItem}
      onClick={() => window.scrollTo(0, 0)}
    >
      <NavLink
        to={path}
        className={classnames(styles.navLink, {[styles.navLinkPassed]: (status > 0)})}
        activeClassName={styles.navLinkActive}
        disabled={disabled}
        component={FancyLink}
      >
        {(typeof stepIcon === 'object')
          ? stepIcon
          : (
            <img
              className={styles.stepIcon}
              src={stepIcon}
              alt="step-icon"
            />
          )
        }
        <div className={styles.hoverTopic}>{hoverTopic}</div>
        <div className={styles.topic}>{topic}</div>
      </NavLink>
      {(Boolean(status)) &&
        <img {...getIconProps()} alt="icon" className={styles.statusIcon}/>
      }
    </div>
  );
};

StepNumber.propTypes = {
  status: PropTypes.number,
  path: PropTypes.string,
  hoverTopic: PropTypes.string,
  topic: PropTypes.string,
  disabled: PropTypes.bool,
};

export default StepNumber;
